import React from 'react';
import { PriceBreakdownWrapper } from './PriceBreakdownWrapper';

interface TransportBreakdownProps {
  priceItems: any[];
  currency: string;
  eurPrices?: any[];
}

export function TransportBreakdown({ priceItems, currency, eurPrices }: TransportBreakdownProps) {
  const TRANSPORT_ITEMS = [
    { id: 20, name: 'Abonnement transport mensuel' },
    { id: 18, name: 'Ticket transport (unité)' },
    { id: 24, name: 'Essence (1 litre)' }
  ];

  const getItemPrice = (itemId: number) => {
    const item = priceItems.find(item => item.item_id === itemId);
    const eurItem = eurPrices?.find(item => item.item_id === itemId);
    
    if (!item) return null;

    return {
      price: item.average_price,
      eurPrice: eurItem?.average_price
    };
  };

  return (
    <PriceBreakdownWrapper title="Prix moyens constatés pour vous aider à estimer votre budget">
      <div className="space-y-2">
        {TRANSPORT_ITEMS.map(item => {
          const prices = getItemPrice(item.id);
          if (!prices) return null;

          return (
            <div key={item.id} className="flex flex-col sm:flex-row sm:items-center sm:justify-between py-2 border-b border-gray-200/50 dark:border-gray-700/50 last:border-0">
              <span className="text-sm text-gray-600 dark:text-gray-400 mb-1 sm:mb-0">
                {item.name}
              </span>
              <div className="text-right font-mono text-base sm:text-sm font-medium text-primary-600 dark:text-primary-400">
                {(prices.eurPrice || prices.price).toFixed(2)} €
              </div>
            </div>
          );
        })}

        {/* Note explicative */}
        <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-600">
          <p className="text-xs text-gray-500 dark:text-gray-400">
            L'abonnement mensuel est généralement l'option la plus économique pour les transports en commun. Le prix de l'essence est donné à titre indicatif pour ceux qui prévoient d'acheter un véhicule.
          </p>
        </div>
      </div>
    </PriceBreakdownWrapper>
  );
}